// Module
var code = "<div> <fg-attach-document-file-list-readonly field-id=\"field.name\" node-id=\"field.schema.nodeId\" form=\"form\" field=\"field\"> </fg-attach-document-file-list-readonly> </div> ";
// Exports
export default code;